import { render, staticRenderFns } from "./register-landing.vue?vue&type=template&id=422bfe30&"
import script from "./register-landing.vue?vue&type=script&lang=js&"
export * from "./register-landing.vue?vue&type=script&lang=js&"
import style0 from "./register-landing.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports